import React from 'react';
import {
  Row, Col, Form, Input,
} from 'antd';
import CurrencyInput from 'react-currency-input';
import PropTypes from 'prop-types';
import { getUserType } from '../../../../../../utils/users';
import './DetailsEdit.scss';
import PrnOxidoField from '../../../../serviceComponents/fieldComponents/prntOxido/PrntOxido';
import PrnCalcarioField from '../../../../serviceComponents/fieldComponents/prntCalcario/PrntCalcario';
import VDesejado from '../../../../serviceComponents/fieldComponents/vDesenjado/VDesejado';

const DetailsEdit = (props) => {
  const {
    initialValuesObject,
    edit,
    detail,
  } = props;

  return (
    <>
      <Row
        gutter={[24, 24]}
        className="zonaManejoDetails__FirstFieldRow"
      >
        <Col
          xs={{ span: 24 }}
          className="zonaManejoDetails__FirstFieldColumn"
        >
          <VDesejado
            min={0}
            max={100}
            name="GEOFERT-ZONA_MANEJO-CONDUTIVIDADE_ELETRICA-V_DESEJADO"
            rules={[]}
            value={initialValuesObject?.['GEOFERT-ZONA_MANEJO-CONDUTIVIDADE_ELETRICA-V_DESEJADO']}
            edit={edit}
          />
        </Col>
      </Row>

      <Row
        gutter={[24, 24]}
        className="zonaManejoDetails__FirstFieldRow"
      >
        <Col
          xs={{ span: 24 }}
          className="zonaManejoDetails__FirstFieldColumn"
        >
          <PrnCalcarioField
            min={0}
            max={100}
            name="GEOFERT-ZONA_MANEJO-CONDUTIVIDADE_ELETRICA-PRNT_CALCARIO"
            rules={[]}
            edit={edit}
            value={initialValuesObject?.['GEOFERT-ZONA_MANEJO-CONDUTIVIDADE_ELETRICA-PRNT_CALCARIO']}
          />
        </Col>
      </Row>

      <Row
        gutter={[24, 24]}
        className="zonaManejoDetails__FirstFieldRow"
      >
        <Col
          xs={{ span: 24 }}
          className="zonaManejoDetails__FirstFieldColumn"
        >
          <PrnOxidoField
            min={130}
            max={180}
            name="GEOFERT-ZONA_MANEJO-CONDUTIVIDADE_ELETRICA-PRNT_OXIDO"
            rules={[]}
            edit={edit}
            value={initialValuesObject?.['GEOFERT-ZONA_MANEJO-CONDUTIVIDADE_ELETRICA-PRNT_OXIDO']}
          />
        </Col>
      </Row>

      {
        getUserType() === 'COOPERCITRUS' && !detail
        && (
          <>
            <Row gutter={[24, 24]}>
              <Col xs={{ span: 24 }}>
                <hr />
                <p className="zonaManejoDetails__SessionTitle">Orçamento</p>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="zonaManejoDetails__FirstFieldRow"
            >
              <Col
                xs={{ span: 24 }}
                className="zonaManejoDetails__FirstFieldColumn"
              >
                <Form.Item
                  className="vantDetails__DesiredSizeFormItem"
                  label={<span className="field-title-text">Valor unitário</span>}
                  name="GEOFERT-ZONA-MANEJO-CONDUTIVIDADE-ELETRICA-VALOR_UNITARIO"
                  rules={[
                    {
                      validator: (rule, value) => {
                        if (value < 0) {
                          return Promise.reject(new Error('Deve ser um numero maior que zero'));
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                  initialValue={
                    (
                      initialValuesObject?.['GEOFERT-ZONA-MANEJO-CONDUTIVIDADE-ELETRICA-VALOR_UNITARIO']
                        ? initialValuesObject['GEOFERT-ZONA-MANEJO-CONDUTIVIDADE-ELETRICA-VALOR_UNITARIO'].replaceAll('.', ',')
                        : '0,00'
                    )
                  }
                >
                  <CurrencyInput
                    allowEmpty="true"
                    className="ant-input"
                    decimalSeparator=","
                    thousandSeparator="."
                    placeholder="0,00"
                    step={0.01}
                    min={0}
                    disabled={edit}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="zonaManejoDetails__FirstFieldRow"
            >
              <Col
                xs={{ span: 24 }}
                className="zonaManejoDetails__FirstFieldColumn"
              >
                <Form.Item
                  className="vantDetails__DesiredSizeFormItem"
                  label={<span className="field-title-text">Valor total</span>}
                  name="GEOFERT-ZONA-MANEJO-CONDUTIVIDADE-ELETRICA-VALOR_TOTAL"
                  rules={[
                    {
                      validator: (rule, value) => {
                        if (value < 0) {
                          return Promise.reject(new Error('Deve ser um numero maior que zero'));
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                  initialValue={
                    (
                      initialValuesObject?.['GEOFERT-ZONA-MANEJO-CONDUTIVIDADE-ELETRICA-VALOR_TOTAL']
                        ? initialValuesObject['GEOFERT-ZONA-MANEJO-CONDUTIVIDADE-ELETRICA-VALOR_TOTAL'].replaceAll('.', ',')
                        : '0,00'
                    )
                  }
                >
                  <CurrencyInput
                    allowEmpty="true"
                    className="ant-input"
                    decimalSeparator=","
                    thousandSeparator="."
                    placeholder="0,00"
                    step={0.01}
                    min={0}
                    disabled={edit}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="zonaManejoDetails__FirstFieldRow"
            >
              <Col
                xs={{ span: 24 }}
                className="zonaManejoDetails__FirstFieldColumn"
              >
                <Form.Item
                  className="vantDetails__DesiredSizeFormItem"
                  label={<span className="field-title-text">Condição de pagamento</span>}
                  name="GEOFERT-ZONA-MANEJO-CONDUTIVIDADE-ELETRICA-CONDICAO_PAGAMENTO"
                  rules={[
                    { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                  ]}
                  initialValue={initialValuesObject?.['GEOFERT-ZONA-MANEJO-CONDUTIVIDADE-ELETRICA-CONDICAO_PAGAMENTO']}
                >
                  <Input
                    style={{ width: '100%' }}
                    disabled={edit}
                    maxLength="255"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="zonaManejoDetails__FirstFieldRow"
            >
              <Col
                xs={{ span: 24 }}
                className="zonaManejoDetails__FirstFieldColumn"
              >
                <Form.Item
                  className="vantDetails__DesiredSizeFormItem"
                  label={<span className="field-title-text">Forma de pagamento</span>}
                  name="GEOFERT-ZONA-MANEJO-CONDUTIVIDADE-ELETRICA-FORMA_PAGAMENTO"
                  rules={[
                    { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                  ]}
                  initialValue={initialValuesObject?.['GEOFERT-ZONA-MANEJO-CONDUTIVIDADE-ELETRICA-FORMA_PAGAMENTO']}
                >
                  <Input
                    style={{ width: '100%' }}
                    disabled={edit}
                    maxLength="255"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="zonaManejoDetails__FirstFieldRow"
            >
              <Col
                xs={{ span: 24 }}
                className="zonaManejoDetails__FirstFieldColumn"
              >
                <Form.Item
                  className="vantDetails__DesiredSizeFormItem"
                  label={<span className="field-title-text">Observações do orçamento</span>}
                  name="GEOFERT-ZONA-MANEJO-CONDUTIVIDADE-ELETRICA-OBSERVACOES"
                  rules={[
                    { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                  ]}
                  initialValue={initialValuesObject?.['GEOFERT-ZONA-MANEJO-CONDUTIVIDADE-ELETRICA-OBSERVACOES']}
                >
                  <Input
                    style={{ width: '100%' }}
                    disabled={edit}
                    maxLength="255"
                  />
                </Form.Item>
              </Col>
            </Row>
          </>
        )
      }

    </>
  );
};

DetailsEdit.propTypes = {
  initialValuesObject: PropTypes.shape({
    'GEOFERT-ZONA_MANEJO-CONDUTIVIDADE_ELETRICA-PRNT_OXIDO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-ZONA_MANEJO-CONDUTIVIDADE_ELETRICA-PRNT_CALCARIO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-ZONA_MANEJO-CONDUTIVIDADE_ELETRICA-V_DESEJADO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-ZONA-MANEJO-CONDUTIVIDADE-ELETRICA-VALOR_UNITARIO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-ZONA-MANEJO-CONDUTIVIDADE-ELETRICA-VALOR_TOTAL': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-ZONA-MANEJO-CONDUTIVIDADE-ELETRICA-CONDICAO_PAGAMENTO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-ZONA-MANEJO-CONDUTIVIDADE-ELETRICA-FORMA_PAGAMENTO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-ZONA-MANEJO-CONDUTIVIDADE-ELETRICA-OBSERVACOES': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  edit: PropTypes.bool,
  detail: PropTypes.bool,
};

DetailsEdit.defaultProps = {
  detail: false,
};

export default DetailsEdit;
